// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COMPETITION = "Sout\u011b\u017e";
export const FORUM_POSTS_SHOW_MORE = "V\u00edce diskuz\u00ed...";
export const FORUM_WHERE_IS_DISCUSSED = "Kde se diskutuje";
export const HOMEPAGE_POST_TYPE_COUNSELLING_TOPIC = "Poradna";
